export default __webpack_public_path__ + "static/media/workStyle.0f4cab3a.svg";